export { default as SendBirdProvider } from './SendbirdProvider.js';
export { default as App } from './App.js';
export { default as ChannelSettings } from './ChannelSettings.js';
export { default as ChannelList } from './ChannelList.js';
export { default as Channel, getAllEmojisFromEmojiContainer, getEmojiCategoriesFromEmojiContainer, getEmojisFromEmojiContainer } from './Channel.js';
import { S as SendbirdSdkContext } from './LocalizationContext-856f8b50.js';
export { g as getStringSet, w as withSendBird } from './LocalizationContext-856f8b50.js';
export { default as OpenChannel } from './OpenChannel.js';
export { default as OpenChannelSettings } from './OpenChannelSettings.js';
export { default as MessageSearch } from './MessageSearch.js';
export { s as sendBirdSelectors } from './index-08d2e2f7.js';
import { useContext } from 'react';
import 'prop-types';
import 'sendbird';
import './actionTypes-6d22a977.js';
import './index-a2dfc026.js';
import 'css-vars-ponyfill';
import './index-0dc47b1c.js';
import './LeaveChannel-49a03e5c.js';
import './index-c18b835b.js';
import './index-96bf4de3.js';
import './utils-bc5765c9.js';
import './index-086d9fcc.js';
import './index-6bcda11a.js';
import './index-784dac56.js';
import './index-5250f817.js';
import 'react-dom';

/**
 * Example:
 * const MyComponent = () => {
 *  const context = useSendbirdStateContext();
 *  const sdk = sendbirdSelectors.getSdk(context);
 *  return (<div>...</div>);
 * }
 */

function useSendbirdStateContext() {
  var context = useContext(SendbirdSdkContext);
  return context;
}

export { useSendbirdStateContext };
//# sourceMappingURL=index.js.map
